import { gql, useMutation } from '@apollo/client'

import { Address, MoneyPayload } from '../../types'

interface Result {
  updateStoreOrder: boolean
}

interface Form {
  id: string
  lineItems: {
    id: string | null
    productId: string
    unitPrice: MoneyPayload
    quantity: number
  }[]
  shippingCost: MoneyPayload
  taxCost?: MoneyPayload
  sendEmail: boolean
  notes: string
  pickup: boolean
  pickupAddress: Address | null
  timingDetails: string
  discountPercent?: number | null
}

const mutation = gql`
  mutation UpdateStoreOrder(
    $id: ID!
    $lineItems: [UpdateStoreOrderLineItem]
    $shippingCost: MoneyInput!
    $taxCost: MoneyInput
    $sendEmail: Boolean!
    $notes: String!
    $pickup: Boolean!
    $pickupAddress: AddressInput
    $timingDetails: String!
    $discountPercent: Float
  ) {
    updateStoreOrder(
      id: $id
      lineItems: $lineItems
      shippingCost: $shippingCost
      taxCost: $taxCost
      sendEmail: $sendEmail
      notes: $notes
      pickup: $pickup
      pickupAddress: $pickupAddress
      timingDetails: $timingDetails
      discountPercent: $discountPercent
    )
  }
`

const useUpdateStoreOrder = () => {
  const [mutate] = useMutation<Result, Form>(mutation)
  return (variables: Form) => mutate({ variables })
}

export default useUpdateStoreOrder
